import { Fragment } from 'react';
import { Trans, useLingui } from '@lingui/react/macro';

import InlineText from '@/design_system/Typography/InlineText';
import Paragraph from '@/design_system/Typography/Paragraph';
import { TRAITS } from '@/models/entity';

import { type ConditionFormQuestion } from '../ConditionQuestion';

export const TraitsReadonly = ({ question }: { question: ConditionFormQuestion }) => {
  const { i18n } = useLingui();

  return (
    <Paragraph>
      <Trans id="settings.organization.data-catalogs.condition-forms.detail.question.quality-control.traits">
        Entities:
      </Trans>{' '}
      <InlineText weight="medium">
        {(question.traits.length > 0 ? question.traits : (['store', 'workshop'] as const)).map(
          (trait, index, traits) => (
            <Fragment key={trait}>
              {i18n._(TRAITS.find((t) => t.id === trait)!.label)}
              {index < traits.length - 1 && ', '}
            </Fragment>
          )
        )}
      </InlineText>
    </Paragraph>
  );
};
